import React from 'react';

import styles from './Container.module.scss';

export default function Container({ className, ...props }) {
  const classes = [styles.container, className] //
    .filter((item) => item)
    .join(' ');

  return <div className={classes} {...props} />;
}
